import ProductSuggestions from '../../../../../pages/vip/features/product-suggestions/product-suggestions.desktop';

export default ProductSuggestions;
